import { getMessaging, getToken, isSupported } from "firebase/messaging"
import { getFirebaseApp } from "./firebaseApp"

// Публичный ключ из Firebase Console → Cloud Messaging → Web Push certificates (VAPID key)
// Пока не подставите реальный ключ, токен получить нельзя.
const VAPID_KEY = "BKqF065rmvBBt7qcnNGTvHW4u885dAvVfgChb1Kuj0pwVisNAW5L_PeuwRqot43Aw7nf8_4aQLxGrhvulEvBbSk"

export function canUseWebPush(): boolean {
    return (
        typeof window !== "undefined" &&
        "serviceWorker" in navigator &&
        "Notification" in window &&
        "PushManager" in window
    )
}

async function registerMessagingSw(): Promise<ServiceWorkerRegistration> {
    return await navigator.serviceWorker.register("/firebase-messaging-sw.js")
}

/**
 * Получить FCM токен БЕЗ запроса разрешения.
 * Вернёт null, если разрешение не выдано или среда не поддерживается.
 */
export async function getExistingFcmToken(): Promise<string | null> {
    if (!canUseWebPush()) return null
    if (Notification.permission !== "granted") return null

    if (VAPID_KEY === "REPLACE_WITH_YOUR_PUBLIC_VAPID_KEY") {
        // Не ломаем приложение — просто считаем, что пуши пока не настроены
        return null
    }

    if (!(await isSupported())) return null

    const app = getFirebaseApp()
    const messaging = getMessaging(app)
    const swReg = await registerMessagingSw()

    const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: swReg })
    return token || null
}

/**
 * Запросить разрешение и получить FCM токен.
 * Используйте в явном пользовательском действии (клик по кнопке).
 */
export async function requestFcmToken(): Promise<string | null> {
    if (!canUseWebPush()) return null

    const permission = await Notification.requestPermission()
    if (permission !== "granted") return null

    return await getExistingFcmToken()
}

